/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type OrgSettings_user = {
    readonly " $fragmentRefs": FragmentRefs<"ZoomSettings_user">;
    readonly " $refType": "OrgSettings_user";
};
export type OrgSettings_user$data = OrgSettings_user;
export type OrgSettings_user$key = {
    readonly " $data"?: OrgSettings_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OrgSettings_user">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgSettings_user",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ZoomSettings_user"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any;
(node as any).hash = 'fbb22c219487ca46e5310301fc3b401a';
export default node;
